import { TAccountProductFullPayloadRequest, TAccountProductShortPayloadRequest, TProductFullPayloadRequest, TProductShortPayloadRequest } from 'src/store';


const serialNumberKey = 'serial_number';
const userNicknameKey = 'user_nickname';
const brandIdKey = 'brand_id';
const isAnaloguesKey = 'is_analogues';

export function getFullSearchParams(searchParams: URLSearchParams): string {
	const userNickname = searchParams.get(userNicknameKey) || '';

	const accountValue = getAccountFullSearchParams(searchParams);
	const value = `${accountValue}&${userNicknameKey}=${userNickname}`;

	return value;
}

export function getShortSearchParams(searchParams: URLSearchParams): string {
	const brandId = searchParams.get(brandIdKey) || '';
	const userNickname = searchParams.get(userNicknameKey) || '';

	const accountValue = getAccountShortSearchParams(searchParams);
	const value = `${accountValue}&${brandIdKey}=${brandId}&${userNicknameKey}=${userNickname}`;

	return value;
}

export function buildFullSearchParams(params: TProductFullPayloadRequest): string {
	const { userNickname } = params;

	const accountValue = buildAccountFullSearchParams(params);
	const value = `${accountValue}&${userNicknameKey}=${userNickname}`;

	return value;
}

export function buildShortSearchParams(params: TProductShortPayloadRequest): string {
	const { userNickname } = params;

	const accountValue = buildAccountShortSearchParams(params);
	const value = `${accountValue}&${userNicknameKey}=${userNickname}`;

	return value;
}

export function getAccountFullSearchParams(searchParams: URLSearchParams): string {
	const serialNumber = searchParams.get(serialNumberKey) || '';
	const brandId = searchParams.get(brandIdKey) || '';
	const isAnalogues = searchParams.get(isAnaloguesKey) || '';

	const value = `${serialNumberKey}=${serialNumber}&${brandIdKey}=${brandId}&${isAnaloguesKey}=${isAnalogues}`;

	return value;
}

export function getAccountShortSearchParams(searchParams: URLSearchParams): string {
	const serialNumber = searchParams.get(serialNumberKey) || '';

	const value = `${serialNumberKey}=${serialNumber}`;

	return value;
}

export function buildAccountFullSearchParams(params: TAccountProductFullPayloadRequest): string {
	const {
		serialNumber,
		brandId,
		isAnalogues,
	} = params;

	const value = `${serialNumberKey}=${serialNumber}&${brandIdKey}=${brandId}&${isAnaloguesKey}=${isAnalogues}`;

	return value;
}

export function buildAccountShortSearchParams(params: TAccountProductShortPayloadRequest): string {
	const { serialNumber } = params;

	const value = `${serialNumberKey}=${serialNumber}`;

	return value;
}
